import {
    Directive,
    ElementRef,
    Input,
    OnInit,
  } from '@angular/core';
  import { DOCUMENT } from '@angular/common';
  import { Renderer2, Inject } from '@angular/core';
  
  @Directive({
    selector: '[tooltipDirective]',
  })
  export class TooltipDirective implements OnInit {
    @Input() data: string;
    @Input() maxCharLength: number;
    @Input() tooltipTextClass: string = '';
    constructor(
      private elementRef: ElementRef,
      private renderer: Renderer2,
      @Inject(DOCUMENT) private document: Document
    ) {}
  
    ngOnInit() {
      if (!this.maxCharLength || (this.maxCharLength && this.data?.length > this.maxCharLength)) {
        const child = this.document.createElement('span');
        child.className = this.tooltipTextClass || 'text';
        child.innerHTML = `<p>${this.data}</p>`;
        this.renderer.appendChild(this.elementRef.nativeElement, child);
      }
    }
  }
